var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('el-button',{staticClass:"c-admin-button",attrs:{"type":"primary","size":_vm.button_size,"icon":"el-icon-setting"},on:{"click":function($event){return _vm.toggleAdminPanel()}}},[_vm._v("管理")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }